<script setup lang="ts">
defineOptions({ inheritAttrs: false })

import { computed } from 'vue'
import VirtualAgentConfigurator from '@/components/BusinessLogic/VirtualAgent/VirtualAgentConfigurator.vue'
import { useRouter } from 'vue-router'
import { useConfigurator } from '@/composables/configurator/useConfigurator.ts'
import { isNotBlank } from '@/utils/String'

interface Props {
  id?: string
}

const props = defineProps<Props>()

const router = useRouter()
const goToListConfigurators = () => {
  const locale = router.currentRoute.value.params.locale as string
  void router.push(`/${locale}/virtual-agents`)
}

const { configurationId } = useConfigurator()

const effectiveId = computed(() => (isNotBlank(props.id) ? props.id : configurationId.value))
const isDuplicate = computed(() => router.currentRoute.value.query.duplicate === 'true')
</script>

<template>
  <DevConfigurator />
  <div class="h-full flex flex-col pt-6 pl-10">
    <VirtualAgentConfigurator
      :id="effectiveId"
      @configuration-cancelled="goToListConfigurators"
      :duplicate="isDuplicate"
    />
  </div>
</template>
